export default {
    inserted(el, binding) {
      const callback = binding.value;
      const observer = new IntersectionObserver(
        (entries, observer) => {
          if (entries[0].isIntersecting) {
            callback();
            observer.disconnect();
          }
        },
        { threshold: 0.1 }
      );
      observer.observe(el);
    }
  }